import { FormattedMessage } from '../../shared/components/formatted-message/formatted-message';
import { ErrorLayout } from '../layouts/error/error';

export function GeoRestricted() {
    return (
        <ErrorLayout
            title={
                <FormattedMessage
                    id={'error.restricted.title'}
                    defaultMessage="Restricted Location"
                />
            }
        >
            <p>
                <FormattedMessage
                    id={'error.restricted.message'}
                    defaultMessage="We're sorry, we're not yet able to operate in your location. If you think this may be in error please contact us."
                />
            </p>
        </ErrorLayout>
    );
}
